<template>
    <v-select v-model="region" :placeholder="placeholder" ref="dropdown"
              :options="regions" label="_name">
        <span slot="no-options">Không tìm thấy</span>
    </v-select>
</template>

<script>
    import {RepositoryFactory} from "../services";
    import { EXCEPT_PROVINCES } from "../constants/Constant";

    const repo = RepositoryFactory.get('regions');
    export default {
        name: "SelectorRegion",
        props: {
            placeholder: {
                type: String,
                default: ''
            },
            isFrom: {
                type: Boolean,
                default: true
            },
            value: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        created() {
            this.listAvailable();
        },
        data() {
            return {
                regions: []
            }
        },
        methods: {
            listAvailable() {
                repo.listAvailable()
                    .then(res => {
                        if (this.isFrom) {
                            this.regions = res.data.data.from.provinces.concat(res.data.data.from.districts).filter(r => {
                                return !Object.values(EXCEPT_PROVINCES).includes(r.id);
                            });
                        } else {
                            this.regions = res.data.data.to.provinces.concat(res.data.data.to.districts).filter(r => {
                                return !Object.values(EXCEPT_PROVINCES).includes(r.id);
                            });
                        }
                    })
                    .catch(err => console.log(err))
            },
            generateValue(val) {
                let objVal = {};
                if (this.isFrom) {
                    if(val._province_id !== undefined && val._province_id !== null) {
                        const from_district = val.id;
                        const _name = val._name;
                        objVal = {...objVal, from_district, _name}
                    } else {
                        const from_province = val.id;
                        const _name = val._name;
                        objVal = {...objVal, from_province, _name}
                    }
                } else {
                    if(val._province_id !== undefined && val._province_id !== null) {
                        const to_district = val.id;
                        const _name = val._name;
                        objVal = {...objVal, to_district, _name}
                    } else {
                        const to_province = val.id;
                        const _name = val._name;
                        objVal = {...objVal, to_province, _name}
                    }
                }
                return objVal;
            },
            openDropDown() {
                if (!this.$refs.dropdown.open) {
                    // this.$refs.dropdown.$refs.toggle.dispatchEvent(new Event('mousedown'));
                    this.$refs.dropdown.open = true;
                }
            },
            closeDropDown() {
                if (this.$refs.dropdown.open) {
                    this.$refs.dropdown.open = false;
                }
            }
        },
        computed: {
            region: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit('input', val);
                }
            }
        }
    }
</script>

<style>

    .v-select.vs--single.vs--searchable {
        background: #fff;
    }

    .vs__dropdown-toggle {
        -moz-appearance: none;
        appearance: none;
    }

    .vs__selected-options {
        display: flex;
        align-items: center;
    }


    .vs__dropdown-menu {
        display: block;
        position: absolute;
        top: calc(100% - 1px);
        /*top: calc(100% - 390px);*/
        left: 0;
        z-index: 1000;
        padding: 5px 0;
        margin: 0;
        width: 100%;
        max-height: 350px;
        min-width: 160px;
        overflow-y: auto;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, .15);
        border: 1px solid rgba(60, 60, 60, .26);
        border-top-style: none;
        border-radius: 0 0 4px 4px;
        text-align: left;
        list-style: none;
        background: #fff;
    }

    .vs__search {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        margin: 0;
        font-variant: tabular-nums;
        list-style: none;
        -webkit-font-feature-settings: 'tnum';
        font-feature-settings: 'tnum';
        position: relative;
        display: inline-block;
        /*width: 100%;*/
        height: 68px;
        padding: 4px 11px 4px 58px;
        color: rgba(0, 0, 0, 0.65);
        font-size: 20px;
        line-height: 1.5;
        background: none;
        /*border: 1px solid #d9d9d9;*/
        border-style: none;
        border-radius: 4px;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
        outline: none;
        appearance: none;
        -moz-appearance: none;
        box-shadow: none;
        width: 0;
        max-width: 100%;
        flex-grow: 1;
        flex-shrink: 0;
        /*flex-basis: 20%;*/
    }

    .vs__actions {
        display: none;
    }

    .vs__selected {
        display: flex;
        align-items: center;
        background-color: #f0f0f0;
        border: 1px solid rgba(60, 60, 60, .26);
        border-radius: 4px;
        color: #333;
        padding-left: 58px;
        font-size: 18px;
        /*background: transparent;*/
        flex-grow: 1;
        flex-shrink: 0;
        /*flex-basis: 80%;*/
    }

    .vs--single .vs__selected {
        background-color: transparent;
        border-color: transparent;
    }

    .vs--single.vs--open .vs__selected {
        position: absolute;
        opacity: .6;
    }

    .vs--single.vs--searching .vs__selected {
        display: none;
    }

    .vs__dropdown-option {
        line-height: 1.42857143;
        display: block;
        padding: 3px 20px;
        clear: both;
        color: #333;
        white-space: nowrap
    }

    .vs__dropdown-option:hover {
        cursor: pointer
    }

    .vs__dropdown-option--highlight {
        background: #5897fb;
        color: #fff
    }
</style>
